import ToolBar from "./components/ToolBar";
import ChatHeader from "./components/ChatHeader";
import { ConversationProps, MessageProps } from "../../typings/messages";
import { GenderType, MessageType } from "../../helpers/Enums";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import {
  sendImageMesssage,
  sendLocationMesssage,
  getMessagesBetweenMembers,
  sendProfileImagesMessage,
  sendTextMesssage,
  sendBreakTheIceMesssage,
} from "../../services/messageService";
import MessageContainer from "./components/MessageContainer";
import { getMemberMedia } from "../../services/mediaService";
import Loader from "react-loader-spinner";
import { setConversation } from "../../redux/carpet";
import NiceModal from "@ebay/nice-modal-react";
import { answerBreakTheIceMessage } from "./../../services/messageService";
import { MemberMediaProps } from "../../typings/memberMedia";
import { getMemberOnlineStatus } from "../../services/memberService";
import { useHistory } from "react-router-dom";
import { hideDropdownToggle } from "../../helpers/Functions";

const ChatScreen = (props: any) => {
  const dispatch = useDispatch();
  let {
    userName,
    memberName,
    memberImage,
    chatMemberCode,
    isNavigateFromProfilePage,
  } = props.location ? props.location.state : props;
  const { memberCode: myMemberCode, genderId: myGenderId } = useSelector(
    (state: RootState) => state.member
  );
  const { conversation } = useSelector((state: RootState) => state.carpet);
  const { hubConnection } = useSelector((state: RootState) => state.app);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [messages, setMessages] = useState<MessageProps[]>([]);
  // const [hasArchiveMessage, setHasArchiveMessage] = useState<boolean>(false);
  const [showArchiveMessage, setShowArchiveMessage] = useState<boolean>(true);
  const [profileImages, setProfileImages] = useState<MemberMediaProps[]>([]);
  const messageRef = useRef<HTMLDivElement | null>(null);
  const history = useHistory();

  useLayoutEffect(() => {
    hubConnection?.on("recievedMessage", (message) => {
      setMessages((prev) => [...prev, message]);
      addMessageConverstion(message);
    });
    hubConnection?.on("updateBreakTheIceMessage", (message) => {
      setMessages((prev) => [
        ...prev.filter((x) => x.messageId !== message.messageId),
        message,
      ]);
      addMessageConverstion(message);
    });
    hubConnection?.invoke(
      "updateMemberChatRoom",
      myMemberCode,
      parseInt(chatMemberCode)
    );
    fetchData();
    return () => {
      hubConnection?.invoke("updateMemberChatRoom", myMemberCode, null);
      setMessages([]);
      setIsLoading(false);
      setShowArchiveMessage(true);
      //setArchiveHasLoaded(false);
    };
  }, [chatMemberCode]);

  useLayoutEffect(() => {
    scrollToBottom();
  }, [messages, isLoading]);

  const fetchData = async () => {
    setIsLoading(true);
    //get messages between two users
    const { data } = await getMessagesBetweenMembers(
      myMemberCode,
      chatMemberCode
    );
    setMessages(data.reverse());
    //get boolean value if user and vistiedMmeber has archiv message
    //const { data: hasArchive } = await userHasArchiveMessage(memberCode, visitedMemberCode);
    //setHasArchiveMessage(hasArchive);
    //get profileImages for sending
    const { data: image } = await getMemberMedia(myMemberCode);
    setProfileImages(image);

    setIsLoading(false);
    updateCountUnreadMessage();
    window.Webflow.destroy();
    window.Webflow.ready();
  };

  const onSend = async (message: string) => {
    let chatMessage = createChatMessage({
      type: MessageType.Text,
      text: message,
      url: undefined,
    });
    const createMessage = {
      text: message,
      memberCode: myMemberCode,
      chatMemberCode: chatMemberCode,
    };
    const { data } = await sendTextMesssage(createMessage);
    UpdateMessage(chatMessage, data);
  };

  const sendImage = async (image: any) => {
    const objectUrl = URL.createObjectURL(image);
    let chatMessage = createChatMessage({
      type: MessageType.Image,
      text: null,
      url: objectUrl,
    });
    const { data }: any = await sendImageMesssage(
      myMemberCode,
      chatMemberCode,
      image
    );
    UpdateMessage(chatMessage, data);
  };

  const sendProfileImages = async (profileImages: any) => {
    //create local messages and upload images to server
    let chatMessage = createChatMessage({
      type: MessageType.Image,
      text: null,
      url: profileImages,
    });
    const { data } = await sendProfileImagesMessage(
      myMemberCode,
      chatMemberCode,
      profileImages
    );
    UpdateMessage(chatMessage, data);
  };

  const sendLocation = useCallback(async () => {
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      if (result.state == "denied") {
        handleBlockedLocation();
      } else {
        navigator.geolocation.getCurrentPosition(async (position) => {
          const location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          let chatMessage = createChatMessage({
            type: MessageType.Location,
            text: null,
            location: location,
          });
          const createMessage = {
            memberCode: myMemberCode,
            chatMemberCode: chatMemberCode,
            latitude: location.latitude,
            longitude: location.longitude,
          };
          const { data } = await sendLocationMesssage(createMessage);
          UpdateMessage(chatMessage, data);
        });
      }
      hideDropdownToggle("w-dropdown-toggle-1");
    });
  }, []);

  const handleBlockedLocation = () => {
    NiceModal.show("action_modal", {
      onNext: () => NiceModal.hide("action_modal"),
      headerTitle: "הרשאת מיקום",
      contentTitle: "אין הרשאת מיקום",
      seconderyButtonText: "בהזדמנות אחרת",
      primaryButtonText: "אישור",
      showCloseButton: true,
      showSeconderyButton: true,
    });
  };

  const sendBreakTheIce = async (data: any) => {
    data.chatMemberCode = chatMemberCode;
    const iceMessage = {
      revicerId: chatMemberCode,
      senderText: data.text,
      reciverText: null,
      question: data.question,
      senderId: myMemberCode,
    };
    let chatMessage = createChatMessage({
      type: MessageType.BreakTheIce,
      text: null,
      breakTheIce: iceMessage,
    });
    const { data: message }: any = await sendBreakTheIceMesssage(data);
    UpdateMessage(chatMessage, message);
  };

  const answerBreakTheIce = async (data: any) => {
    data.chatMemberCode = chatMemberCode;
    const { data: message }: any = await answerBreakTheIceMessage(data);
    updateBreakTheIceMessage(message);
  };

  const updateBreakTheIceMessage = (message: any) => {
    const newMessages = messages.filter(
      (x) => x.messageId !== message.messageId
    );
    setMessages([...newMessages, message]);
  };

  const scrollToBottom = () => {
    // document.querySelector(".content_sec.full.wf-section")!.scrollTop = document.querySelector(
    //     ".content_sec.full.wf-section"
    // )!.scrollHeight;

    const element = window.document.querySelector(".chat-container");
    if (element !== null) {
      element.scrollTo(0, element.scrollHeight);
      //element.scrollTop = element.scrollHeight;
    }
  };

  const createChatMessage = (data: any) => {
    const message: MessageProps = {
      messageId: Date.now(),
      text: data.text,
      chatMemberCode: myMemberCode,
      createdAt: new Date(),
      messageTypeId: data.type,
      image: data.type === MessageType.Image ? data.url : undefined,
      video: data.type === MessageType.Video ? data.url : undefined,
      audio: data.type === MessageType.Audio ? data.url : undefined,
      location: data.type === MessageType.Location ? data.location : undefined,
      breakTheIce:
        data.type === MessageType.BreakTheIce ? data.breakTheIce : undefined,
      pending: true,
      sent: false,
    };
    setMessages((prev) => [...prev, message]);
    addMessageConverstion(message);
    return message;
  };

  const UpdateMessage = (
    localMesssage: MessageProps,
    messageFormServer: MessageProps
  ) => {
    setMessages((prev) => {
      const toUpdate = prev.find(
        (m) => m.createdAt === localMesssage.createdAt
      );
      if (toUpdate) {
        toUpdate.messageId = messageFormServer.messageId;
        toUpdate.sent = true;
        toUpdate.pending = false;
      }
      return [...prev];
    });
  };

  const addMessageConverstion = (message: MessageProps) => {
    const conversations = [...conversation];
    let filterdConversations = conversations.filter(
      (x) => x.memberCode !== chatMemberCode
    );
    const item: ConversationProps = {
      lastMessage: message.text ?? null,
      memberCode: chatMemberCode,
      memberImageUrl: memberImage,
      messageTypeId: message.messageTypeId,
      memberName,
      newMessagesCount: 0,
      userName,
    };
    dispatch(setConversation([item, ...filterdConversations]));
  };

  const updateCountUnreadMessage = () => {
    const conversations = [...conversation];
    let index = conversation.findIndex((x) => x.memberCode === chatMemberCode);
    if (index !== -1) {
      conversations[index].newMessagesCount = 0;
    }
    dispatch(setConversation(conversations));
  };

  const openBreakTheIceModal = () => {
    NiceModal.show("breakTheIce_modal", {
      handleNext: sendBreakTheIce,
    });
  };

  const chatHeaderProps = {
    memberCode: chatMemberCode,
    memberName: memberName,
    isNavigateFromProfilePage: isNavigateFromProfilePage,
    memberImage: memberImage,
    userName,
  };

  const messageContainerProps = {
    answerBreakTheIce,
    sendBreakTheIce,
    chatMemberImage: memberImage,
    messages,
    memberCode: myMemberCode,
    chatRecipientNickName: userName,
  };

  const toolBarProps = {
    sent: onSend,
    sendLocation,
    sendImage,
    sendProfileImages,
    openBreakTheIceQuestion: openBreakTheIceModal,
    profileImages,
  };

  return (
    <>
      <div className="top_sec chat wf-section">
        <ChatHeader {...chatHeaderProps} />
      </div>
      <div className="content_sec full wf-section">
        <div className="content_block chat">
          <div
            ref={messageRef}
            className="chat_talk_group"
            style={messages.length === 0 ? { marginTop: "30vh" } : {}}
          >
            {isLoading ? (
              <div
                style={{
                  height: "60vh",
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Loader
                  type="ThreeDots"
                  color="#f47373"
                  height={60}
                  width={60}
                />
              </div>
            ) : messages.length > 0 ? (
              <MessageContainer {...messageContainerProps} />
            ) : (
              <>
                <div style={{ textAlign: "center" }}>
                  {/* {myGenderId === GenderType.MALE ? "כדי לשבור את הקרח עם משחק נחמד, לחץ כאן" : "כדי לשבור את הקרח עם משחק נחמד, לחצי כאן"}
                                 <div style={{ textAlign: 'center' }}>
                                    {myGenderId === GenderType.MALE ? "(או כתוב הודעה רגילה בתיבה בתחתית העמוד)" : "(או כתבי הודעה רגילה בתיבה בתחתית העמוד)"}
                                 </div> */}
                  אפשר ללחוץ כאן כדי לשבור את הקרח עם משחק נחמד, או לכתוב הודעה
                  רגילה בתיבה למטה.
                </div>
                <a
                  href="#"
                  onClick={openBreakTheIceModal}
                  className="chat_arch_button red w-button"
                >
                  שבור את הקרח
                </a>
              </>
            )}
          </div>
        </div>
        <div className="chat_insert_sec wf-section">
          <div className="content_block footer">
            <div className="chat_insert_content w-clearfix">
              <ToolBar {...toolBarProps} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatScreen;
